export default __webpack_public_path__ + "static/media/rtf.0fec1ff2.svg";